import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SimpleListMenu from './SimpleListMenu';
import ClientProvider from './client';
export default createDemo(import.meta.url, SimpleListMenu, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/menus/demos/simple-list/SimpleListMenu.tsx",
    "fileName": "SimpleListMenu.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemText from '@mui/material/ListItemText';\nimport MenuItem from '@mui/material/MenuItem';\nimport Menu from '@mui/material/Menu';\n\nconst options = [\n  'Show some love to MUI',\n  'Show all notification content',\n  'Hide sensitive notification content',\n  'Hide all notification content',\n];\n\nexport default function SimpleListMenu() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);\n  const [selectedIndex, setSelectedIndex] = React.useState(1);\n  const open = Boolean(anchorEl);\n  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {\n    setAnchorEl(event.currentTarget);\n  };\n\n  const handleMenuItemClick = (\n    event: React.MouseEvent<HTMLElement>,\n    index: number,\n  ) => {\n    setSelectedIndex(index);\n    setAnchorEl(null);\n  };\n\n  const handleClose = () => {\n    setAnchorEl(null);\n  };\n\n  return (\n    <div>\n      <List\n        component=\"nav\"\n        aria-label=\"Device settings\"\n        sx={{ bgcolor: 'background.paper' }}\n      >\n        <ListItemButton\n          id=\"lock-button\"\n          aria-haspopup=\"listbox\"\n          aria-controls=\"lock-menu\"\n          aria-label=\"when device is locked\"\n          aria-expanded={open}\n          onClick={handleClickListItem}\n        >\n          <ListItemText\n            primary=\"When device is locked\"\n            secondary={options[selectedIndex]}\n          />\n        </ListItemButton>\n      </List>\n      <Menu\n        id=\"lock-menu\"\n        anchorEl={anchorEl}\n        open={open}\n        onClose={handleClose}\n        slotProps={{\n          list: {\n            'aria-labelledby': 'lock-button',\n            role: 'listbox',\n          },\n        }}\n      >\n        {options.map((option, index) => (\n          <MenuItem\n            key={option}\n            disabled={index === 0}\n            selected={index === selectedIndex}\n            onClick={(event) => handleMenuItemClick(event, index)}\n          >\n            {option}\n          </MenuItem>\n        ))}\n      </Menu>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 81,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemText from '@mui/material/ListItemText';\nimport MenuItem from '@mui/material/MenuItem';\nimport Menu from '@mui/material/Menu';\n\nconst options = [\n  'Show some love to MUI',\n  'Show all notification content',\n  'Hide sensitive notification content',\n  'Hide all notification content',\n];\n\nexport default function SimpleListMenu() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);\n  const [selectedIndex, setSelectedIndex] = React.useState(1);\n  const open = Boolean(anchorEl);\n  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {\n    setAnchorEl(event.currentTarget);\n  };\n\n  const handleMenuItemClick = (\n    event: React.MouseEvent<HTMLElement>,\n    index: number,\n  ) => {\n    setSelectedIndex(index);\n    setAnchorEl(null);\n  };\n\n  const handleClose = () => {\n    setAnchorEl(null);\n  };\n\n  return (\n    <div>\n      <List\n        component=\"nav\"\n        aria-label=\"Device settings\"\n        sx={{ bgcolor: 'background.paper' }}\n      >\n        <ListItemButton\n          id=\"lock-button\"\n          aria-haspopup=\"listbox\"\n          aria-controls=\"lock-menu\"\n          aria-label=\"when device is locked\"\n          aria-expanded={open}\n          onClick={handleClickListItem}\n        >\n          <ListItemText\n            primary=\"When device is locked\"\n            secondary={options[selectedIndex]}\n          />\n        </ListItemButton>\n      </List>\n      <Menu\n        id=\"lock-menu\"\n        anchorEl={anchorEl}\n        open={open}\n        onClose={handleClose}\n        slotProps={{\n          list: {\n            'aria-labelledby': 'lock-button',\n            role: 'listbox',\n          },\n        }}\n      >\n        {options.map((option, index) => (\n          <MenuItem\n            key={option}\n            disabled={index === 0}\n            selected={index === selectedIndex}\n            onClick={(event) => handleMenuItemClick(event, index)}\n          >\n            {option}\n          </MenuItem>\n        ))}\n      </Menu>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 81,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/List",
      "@mui/material/ListItemButton",
      "@mui/material/ListItemText",
      "@mui/material/MenuItem",
      "@mui/material/Menu"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
